/**
 * EUR-Lex ELI URL builder.
 * Builds permalink URLs for EUR-Lex articles using the ELI standard.
 */
import type { ActId } from '@/types';

const CELEX_MAP: Record<ActId, string> = {
  amld:  '32024L1640',
  amlr:  '32024R1624',
  amlar: '32024R1620',
  tfr:   '32023R1113',
};

export function buildEliUrl(actId: ActId, articleNum: number | string, lang = 'eng'): string {
  const celex = CELEX_MAP[actId];
  const langCode = lang === 'eng' ? 'EN' : 'IT';
  return `https://eur-lex.europa.eu/legal-content/${langCode}/TXT/HTML/?uri=CELEX:${celex}#art_${articleNum}`;
}
